<template>
    <div div name="pc-connci-sub1" class="pc-barocare-connci-sub2">
        <template>
            <BarocareConciHeaderSub />
        </template>
        <div class="sub2-container">
          <div class="main-content">
            <div class="left-sidebar">
                <nav class="navigation">
                    <ul>
                        <li><router-link to="/barocarenew">메인으로</router-link></li>
                        <li><router-link to="/barocarenew/sub2">서비스 특장점</router-link></li>
                        <li><router-link to="/barocarenew/sub3">이용방법</router-link></li>
                        <li class="select"><router-link to="/barocarenew/sub1">구매 가능 품목</router-link></li>
                        <li><router-link to="/barocarenew/sub5">인슐린 약국 찾기</router-link></li>
                        <li><router-link to="/barocarenew/sub4">자주 묻는 질문</router-link></li>
                    </ul>
                </nav>
            </div>

            <div class="content">
                <div>
                    <span class="main-title">구매 가능 품목</span>
                </div>
                <div>
                    <span class="main-description">구매를 희망하는 경우<br>
                        서비스 이용하기 버튼을 선택해 주세요</span>
                </div>
                
                <div class="row-space-between" style="margin-top: 59px;">
                    <input class="search-input" v-model="keyword" placeholder="상품명, 제조사명을 검색해보세요" @keyup.enter="searchItems"/>
                    <img src="../assets/pc_diabetes/search_icon.png" class="search-icon"/>
                    <button class="search-button" @click="searchItems">검색</button>
                </div>
                <div class="select-bar" style="margin-top: 10px;">
                    <div :class="{'select-button-active': category === 3, 'select-button-inactive': category !== 3}" @click="categoryChange(3)">연속혈당측정기</div>
                    <div :class="{'select-button-active': category === 0, 'select-button-inactive': category !== 0}" @click="categoryChange(0)">주사기/펜니들</div>
                    <div :class="{'select-button-active': category === 1, 'select-button-inactive': category !== 1}" @click="categoryChange(1)">혈당검사지</div>
                    <div :class="{'select-button-active': category === 2, 'select-button-inactive': category !== 2}" @click="categoryChange(2)">채혈침</div>
                </div>
                <div class="column-wrapper" v-if="list !== null" style="margin-top: 20px;">
                    <span v-if="countView" class="search-count-text">검색 결과&nbsp; {{ count }}개</span>
                   
                    <img class="ad-card" style="width: 648px;" v-if="count > 0 && category === 3" src="../assets/pc_diabetes/ad_card_new.png" />
                    <div class="item-card" v-for="(item, index) in list" v-if="count > 0">
                        <div class="row-space-between">
                            <div class="column-wrapper">
                                <span class="item-card-category">{{ convertCategory(item.category) }}</span>
                                <span class="item-card-bold" style="width: 387px;">{{ item.name }}</span>
                                <span class="item-card-info">{{ item.company }}</span>
                            </div>
                            <div class="column" v-if="category === 3">                         
                                <span class="info-text" style="margin-top: 6px;">보험급여 적용 상품 | <span style="text-decoration: line-through;">{{ setComma(item.price) }}원</span></span>                         
                                <div class="row-wrapper" style="margin-top: 12px;" v-if="item.id !== 3">
                                    <div class="under-19">19세 미만</div>
                                    <span class="red">-90%</span>
                                    <span class="price">{{ setComma(item.price * 0.1)}}원</span>
                                </div>
                                <div class="row-wrapper" style="margin-top: 10px;">
                                    <div class="over-19">19세 이상</div>
                                    <span class="red">-70%</span>
                                    <span class="price">{{ setComma(item.price * 0.3)}}원</span>
                                </div>
                            </div>
                            <div class="column" v-else>                         
                                <span class="info-text" style="margin-top: 23px;">보험급여 적용 상품 | <span style="text-decoration: line-through;">{{ setComma(item.price) }}원</span></span>                         
                                <div class="row-wrapper-end" style="margin-top: 12px;">
                                    <span class="red">-90%</span>
                                    <span class="price">{{ setComma(item.price * 0.1)}}원</span>
                                </div>                               
                            </div>
                        </div>               
                    </div>
                    <div class="search-no-result">
                        <div class="row">
                            <div class="question-mark">?</div>
                            <span class="search-no-result-title">홈페이지에 없는 상품은?</span>
                        </div>
                        <div class="row" style="margin-top: 10px;">
                            <span class="search-no-result-text">홈페이지에 없는 상품은 솔닥 컨시어지 고객센터로 문의해 주세요.<br>
                                빠르게 주문 가능 여부를 확인한 후 답변해드리겠습니다.</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="right-sticky-menu box">
                <div class="box-top" style="padding-bottom: 190px;">
                  <strong><i class="ico-quest"></i>홈페이지에 없는 상품은?</strong>
                  <p>홈페이지에 없는 상품은 솔닥 컨시어지 고객센터로 문의해 주세요.<br>
                    빠르게 주문 가능 여부를 확인한 후 답변해드리겠습니다.</p>
                </div>
                <!-- <div class="box-bot" style="margin-top: 52px;">
                  <div class="left">
                    <strong>솔닥 컨시어지</strong>
                    <span>카카오톡 상담 바로가기</span>
                  </div>
                  <div class="right">
                    <img src="../assets/pc_barocare_conci/img-qr.png" alt="카카오톡 상담 큐알코드">
                  </div>
                </div> -->
            </div>
          </div>
       </div>
    </div>
</template>

<script>
import BarocareConciHeaderSub from '@/components/pc_barocare_conci/BarocareConciHeaderSub';
import axios from 'axios'

export default {
    name: 'BarocareConciSub1Pc',
    components: {
        BarocareConciHeaderSub,
    },
    data() {
        return {
            // 현재 경로가 서브 페이지인지를 체크
            isSubPage: this.$route.path.includes('/sub'),
            category: 3,  // 주사기/펜니들
            keyword: '',
            list: null,
            countView: false,
            count: 0
        };
    },
    watch: {
        // 경로가 변경될 때마다 isSubPage 값을 업데이트
        '$route.path'(newPath) {
            this.isSubPage = newPath.includes('/sub');
        }
    },
    mounted() {
        // 페이지가 로드되면 스크롤을 맨 위로
        $('html').animate({
            scrollTop: 0
        }, 100);

        // 스크롤 이벤트 리스너 추가
        window.addEventListener('scroll', this.updateActiveSection);
        this.searchItemsInit();
    },
    beforeDestroy() {
        // 컴포넌트 파괴 전 스크롤 이벤트 리스너 제거
        window.removeEventListener('scroll', this.updateActiveSection);
    },
methods: {
    categoryChange: function(category)
    {
        if(this.category === category)
        {
            return;
        }

        this.category = category;
        // 빈 검색
        this.keyword = '';
        this.searchItemsInit();
    },
    searchItemsInit: async function()
    {
        
        try {
            let query = this.keyword;
            if(query === '')
            {   
                query = "empty_keyword";
            }
                
            const url = `https://dbapi.soldoc.co.kr/soldoc/diabetes/item/category/search//${this.category}/${query}`;                   
            const response = await axios.get(url);
            
            console.log("response >>", response.data)     
            this.list = response.data.data;
            if(this.list != null)
            {
                this.count = this.list.length;
                this.countView = false;
            }
        } catch(err) {
            console.log("Error >>", err);
        }
    },
    searchItems: async function()
    {
        try {
            let query = this.keyword;
            if(query === '')
            {   
                query = "empty_keyword";
            }
                
            const url = `https://dbapi.soldoc.co.kr/soldoc/diabetes/item/category/search//${this.category}/${query}`;                   
            const response = await axios.get(url);
            this.countView = true;
            console.log("response >>", response.data)     
            this.list = response.data.data;
            if(this.list != null)
            {
                this.count = this.list.length;
            }
        } catch(err) {
            console.log("Error >>", err);
        }
    },
    convertCategory: function(category)
    {
        if(category === 0)
        {
            return '주사기/펜니들'
        }
        else if(category === 1)
        {
            return '혈당검사지'
        }
        else if(category === 2)
        {
            return '채혈침'         
        }
        else if(category === 3)
        {
            return '연속혈당측정기'
        }
        
    },
    setComma: function(num)
    {
        var regexp = /\B(?=(\d{3})+(?!\d))/g;
        return num.toString().replace(regexp, ',')
    },
    scrollToSection(sectionId) {
        const element = document.getElementById(sectionId);
        if (element) {
            const offsetTop = element.getBoundingClientRect().top + window.pageYOffset - 77;

            // 스크롤 이동
            window.scrollTo({
                top: offsetTop,
                behavior: 'smooth'
            });
        }
    },
    updateActiveSection() {
        const sections = document.querySelectorAll('.section');
        const menuItems = document.querySelectorAll('.right-sticky-menu li');
        
        // 모든 메뉴 아이템에서 'selected' 클래스 제거
        menuItems.forEach(item => item.classList.remove('selected'));

        // 가장 가까운 섹션을 추적
        let closestSection = null;
        let minDistance = Infinity; // 윈도우 상단과의 최소 거리
        
        // 현재 윈도우 상단에 가장 가까운 섹션 찾기
        for (let section of sections) {
            const rect = section.getBoundingClientRect();
            const sectionHeight = section.offsetHeight;
            
            // 섹션의 top 값과 윈도우 상단과의 거리를 계산
            const distanceFromTop = Math.abs(rect.top);
            
            // 최소 거리를 찾음
            if (distanceFromTop < minDistance) {
                minDistance = distanceFromTop;
                closestSection = section;
            }
        }

        // 가장 가까운 섹션에 selected 클래스 추가
        if (closestSection) {
            const sectionId = closestSection.id;
            const activeMenuItem = [...menuItems].find(
                item => item.querySelector('a').getAttribute('href') === `#${sectionId}`
            );
            
            if (activeMenuItem) {
                activeMenuItem.classList.add('selected');
            }
        }
    }
}
}
</script>
<style lang="scss">
@import "../styles/PcBarocareConci.scss";
</style>

<style scoped>
    .main-title {
        color: #333;
        font-family: Pretendard;
        font-size: 32px;
        font-style: normal;
        font-weight: 600;
        line-height: 52px; /* 162.5% */
        letter-spacing: -0.64px;
    }
    .main-description {
        color: #666;
        font-family: Pretendard;
        font-size: 17px;
        font-style: normal;
        font-weight: 400;
        line-height: 28px; /* 164.706% */
        letter-spacing: -0.34px;
    }
    .search-input {
        display: flex;
        width: 547px;
        height: 44px;
        padding: 2px 52px;
        align-items: center;
        gap: 3px;
        flex-shrink: 0;
        border: 0;
        border-radius: 30px;
        background: #F3F5F8;

    }
    .search-icon {
        position: absolute;
        left: 12px;
        top: 2px;
        height: 40px;
        cursor: pointer;
    }
    .search-button {
        display: flex;
        width: 101px;
        height: 43px;
        justify-content: center;
        align-items: center;
        border-radius: 21.5px;
        background: #333;
        color: #FFF;
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 30px; /* 187.5% */
        letter-spacing: -0.32px;
        border: 0;
    } 
    /* select bar */
    .select-bar {
        display: flex;
        width: 100%;
        height: 58px;
        padding: 0 9px;   
        justify-content: space-between;
        align-items: center;
        border-radius: 10px;
        background: #F3F5F8;
    }
    .select-button-inactive {
        display: flex;
        width: 150px;
        height: 40px;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
        color: #6B7684;
        text-align: center;
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 30px; /* 187.5% */
        letter-spacing: -0.32px;
        cursor: pointer;
        border-radius: 10px;
        background: #F3F5F8;
    }   
    .select-button-active {
        display: flex;
        width: 150px;
        height: 40px;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
        text-align: center;
        color: #333;
        text-align: center;
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 30px; /* 187.5% */
        letter-spacing: -0.32px;
        border-radius: 10px;
        background: #FFF;
        cursor: pointer;
    }  

    /* item card */
    .item-card {
        width: 100%;
        border-radius: 10px;
        background: #F9FAFB;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        padding: 15px 22px;
        flex-direction: column;
        margin-bottom: 10px;
    }
    .item-card-category {
        color: #1E4A96;
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 30px; /* 187.5% */
        letter-spacing: -0.32px;
    }
    .item-card-bold {
        color: #333;
        font-family: Pretendard;
        font-size: 22px;
        font-style: normal;
        font-weight: 600;
        line-height: 40px; /* 181.818% */
        letter-spacing: -0.44px;
    }
    .item-card-info {
        color: #777;
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 28px; /* 200% */
        letter-spacing: -0.28px;
    }

    .column-wrapper {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
    }
    .row-space-between {
        display: flex;
        width: 100%;
        justify-content: space-between;
        align-items: column;
        position: relative;
    }
    .search-no-result {
        display: flex;
        width: 100%;
        box-sizing: border-box;
        padding: 20px;
        align-items: flex-start;    
        justify-content: flex-start;
        flex-direction: column;
        border-radius: 10px;
        background: #E1F2FF;
    }
    .question-mark {
        color: #FFF;
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 24px; /* 150% */
        letter-spacing: -0.32px;
        display: flex;
        width: 18px;
        height: 18px;
        justify-content: center;
        align-items: center;
        background: #1E4A96;
        border-radius: 50%;
        margin-right: 7px;

    }
    .row {
        display: flex;
        width: 100%;
        justify-content: flex-start;
        align-items: center;
        margin-left: 0px;
    }
    .search-no-result-title {
        color: #1E4A96;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 24px; /* 133.333% */
        letter-spacing: -0.36px;
    }
    .search-no-result-text{
        color: #333;
        font-family: Pretendard;
        font-size: 17px;
        font-style: normal;
        font-weight: 400;
        line-height: 28px; /* 164.706% */
        letter-spacing: -0.34px;
    }
    .search-count-text {
        color: #333;
        font-family: Pretendard;
        font-size: 17px;
        font-style: normal;
        font-weight: 600;
        line-height: 28px; /* 164.706% */
        letter-spacing: -0.34px;
        margin-bottom: 14px;
    }
    .ad-card {
        margin-bottom: 10px;
    }
    .column {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
    }
    .under-19 {
        display: flex;
        width: 60px;
        height: 20px;
        justify-content: center;
        align-items: center;
        border-radius: 4px;
        border: 1px solid #CCC;
        background: #FFF;
        color: #333;
        font-family: Pretendard;
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: 40px; /* 307.692% */
        letter-spacing: -0.26px;
    }
    .over-19 {
        display: flex;
        width: 60px;
        height: 20px;
        justify-content: center;
        align-items: center;
        border-radius: 4px;
        background: #333333;
        color: #FFF;
        font-family: Pretendard;
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: 40px; /* 307.692% */
        letter-spacing: -0.26px;
    }
    .red {
        color: #F07824;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px; /* 111.111% */
        letter-spacing: -0.36px;
        margin-left: 8px;
    }
    .row-wrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .row-wrapper-end {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        width: 100%;
    }
    .price {
        color: #333;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px; /* 111.111% */
        letter-spacing: -0.36px;
        width: 87px;
        text-align: right;
    }
    .info-text {
        color: #999;
        font-family: Pretendard;
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: 14px; /* 107.692% */
        letter-spacing: -0.26px;
        text-align: right;
        width: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/page/PcBarocareSub1.vue